<template>
    <div class="c-standard-summary">
        <b-card no-body>
            <b-card-body>
                <b-row class="mb-3">
                    <b-col>
                        <b-link href="#"  @click="open" class="card-header-action btn-setting pull-right">
                            <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Réservation')}}
                        </b-link>
                    </b-col>
                </b-row>
                <b-row v-for="booking, bookingIndex in dataBookings">
                    <b-col>
                        <table class="table">
                            <td width="40px">
                                <b-btn class="btn btn-sm btn-light pull-right" @click="collapse(bookingIndex)"><i class="fa fa-chevron-down"></i></b-btn>
                            </td>
                            <td>
                                {{Core.Value.readable('date', 'start', booking.start)}}
                            </td>
                            <td>
                                {{booking.title}}
                            </td>
                            <td>
                                <div v-if="booking.user.firstname !== ''">
                                    <label>{{booking.user.firstname}} {{dataBookings[bookingIndex].user.lastname}}</label><br/>
                                </div>
                                <UserAction
                                        v-if="booking.user.firstname === ''"
                                        v-model="dataBookings[bookingIndex].user"
                                        :options="{ reset: { display: false }, add: { display: true }  }"></UserAction>
                            </td>
                            <td>
                                <b-button v-if="booking.user.firstname !== ''" class="mr-1 btn btn-sm" variant="danger"><i class="fa fa-times"></i></b-button>
                            </td>
                            <td>
                                <InputQuantity class="mt-1" v-model="booking.quantity"></InputQuantity>
                            </td>
                            <td>
                                {{Core.Value.readable('select', 'status', booking.status, Core.EventDateBooking.statusOptions())}}
                            </td>
                            <td>
                                <b-button @click="onTrashClick(bookingIndex)" class="btn btn-danger btn-sm"><i
                                        class="fa fa-trash-o"></i></b-button>
                            </td>
                        </table>

                        <b-collapse v-model="dataBookings[bookingIndex].collapse" class="mt-2">


                        </b-collapse>

                    </b-col>
                </b-row>

                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Nouvelle participation')"
                        ref="modalInstanceSelector"
                        root="/event-date/list"
                        v-model="dataEventDates"
                        :multiple="true"
                        :searchFormStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'datePicker'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'type'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'datePicker',
                                        type: 'datePicker',
                                        isInline: false,
                                        label: Core.Definition.getDefinition('Date'),
                                        value: null
                                    },
                                    {
                                        id: 'type',
                                        type: 'select',
                                        label: Core.Definition.getDefinition('Type d\'événement'),
                                        value: null,
                                        onSelect: function() {}
                                    }
                                ]
                         }"
                        :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucune date à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Type'),
                                    key: 'type',
                                    type: 'select',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>
            </b-card-body>
        </b-card>
    </div>
</template>


<script>
    import ModalInstanceSelector from './ModalInstanceSelector'
    import ModalUser from './ModalUser'
    import UserAction from './UserAction'
    import InputQuantity from './InputQuantity'

    export default {
        name: 'BookingsSummary',
        components: {
            InputQuantity,
            ModalInstanceSelector,
            ModalUser,
            UserAction
        },
        props: {
            caption: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataBookings = val
                },
                deep: true
            },
            dataBookings: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            },
            dataEventDates: {
                handler(val) {
                    this.evalBookings()
                },
                deep: true
            }
        },
        mounted() {
            this.dataBookings = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataBookings: [],
                dataTrashModal: {
                    show: false,
                    index: ''
                },
                dataEventDates: []
            }
        },
        methods: {
            evalBookings() {
                for(let eventDateIndex in this.dataEventDates) {
                    let eventDate = this.dataEventDates[eventDateIndex].instance
                    let quantity = this.dataEventDates[eventDateIndex].quantity
                    if (this.dataBookings.length > 0) {
                        for(let booking in this.dataBookings) {
                            booking = this.dataBookings[booking]
                            let sameBookings = window.Core.Array.findAllByKey(this.dataBookings, 'eventDateId', eventDate.id)
                            if (sameBookings === false || sameBookings.length < quantity) {
                                this.addBooking(eventDate.id, eventDate.title, eventDate.start, eventDate.end, window.Core.EventDateBooking.statusRegistered)
                            }
                        }
                    } else {
                        this.addBooking(eventDate.id, eventDate.title, eventDate.start, eventDate.end, window.Core.EventDateBooking.statusRegistered)
                    }
                }
            },
            addBooking(eventDateId, title, start, end, status) {
                this.dataBookings.push(
                    {
                        quantity: '1',
                        eventDateId: eventDateId,
                        title: title,
                        start: start,
                        end: end,
                        status: status,
                        user: {
                            firstname: '',
                            lastname: '',
                            email: '',
                            phone: '',
                            mobile: '',
                            birthDate: null
                        }
                    }
                )
            },
            onTrashClick(bookingIndex) {
                this.dataBookings.splice(bookingIndex, 1)
                this.eval()
            },
            open() {
                this.$refs.modalInstanceSelector.open = true
            }
        }
    }
</script>
